[].forEach.call(document.querySelectorAll('.list a'), (box) => {
    const color = box.getAttribute('data-color');

    box.addEventListener('click', (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(color);
    });
});
